<rt-button (click)="expand.emit()" variant="plain"> {{ text }} </rt-button>

@if (withDivider) {
  <rt-divider />
}
